import { matchPath, useLocation } from 'react-router';

// Null off a career page. The Hub then asks the catalog for an unscoped handful.
export const useHubStoryOccupationId = (): string | null => {
    const { pathname } = useLocation();

    const match = matchPath('/careers/:occupationId/*', pathname)
        ?? matchPath('/careers/:occupationId', pathname);

    return match?.params?.occupationId ?? null;
};
